module.exports = __webpack_public_path__ + "img/4.ddf5b819.png";